import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/Footer.tsx");
